import React, { useEffect, useMemo } from 'react';
import classNames from 'classnames';
import useCallbackRef from 'hooks/useCallbackRef';
import { formatPercentage } from 'utils';

import './CircleProgress.styles.scss';
import './CircleProgress.styles.responsive.scss';

type CircleProgressProps = {
  className?: string;
  isValueDisplayed?: boolean;
  value: number;
};

const CircleProgress: React.FC<CircleProgressProps> = (props) => {
  const { className, isValueDisplayed, value } = props;
  const [container, containerRef] = useCallbackRef<HTMLDivElement>(null);

  const classes = classNames('circle-progress', className);

  const formattedValue = useMemo(() => formatPercentage(value), [value]);

  useEffect(() => {
    if (!container) return;

    container.style.setProperty('--progress-value', formattedValue);
  }, [container, formattedValue, value]);

  return (
    <div
      ref={containerRef}
      className={classes}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={value}
      aria-valuetext={formattedValue}
      data-percentage={formattedValue}
    >
      {isValueDisplayed ? formatPercentage(Math.round(value)) : null}
    </div>
  );
};

export default CircleProgress;
